import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useNoticeBannersStackActions } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Tells the guest none of the products could be added. The bundle stays open
 * with every product still selected.
 */
export const useBundleFailedToAddToBagNotice = () => {
  const { formatMessage } = useIntl();
  const { push: addNoticeBanner } = useNoticeBannersStackActions();

  return useCallback(() => {
    addNoticeBanner({
      palette: 'caution',
      text: formatMessage(messages.failedToAddToBag),
      autoHideTimeout: NOTICE_AUTO_HIDE_TIMEOUT,
    });
  }, [addNoticeBanner, formatMessage]);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const NOTICE_AUTO_HIDE_TIMEOUT = 4000;

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  failedToAddToBag: {
    defaultMessage: 'We couldn’t add selected products. Please try again later.',
    description: 'Bundle | Added to bag notice | No product could be added',
  },
});
